var map = {
	"./banner1CN.png": "421f",
	"./banner1EN.png": "2100",
	"./banner2CN.png": "69fb",
	"./banner2EN.png": "06a5",
	"./banner3CN.png": "6c30",
	"./banner3EN.png": "f805"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c149";